import { Component, OnInit } from '@angular/core';
import { SystemService } from '../../services/system.service';
import { MessageService, Message } from 'primeng/api';


@Component({
  templateUrl: './audit.component.html'
})
export class AuditComponent implements OnInit {

  auditList: any[];
  allAuditList: any[];
  filteredValuesCount = 0;
  displayState: any = {
    workingDiv: false,
    gridDiv: true,
  };
  constructor(private systemService: SystemService, private messageService: MessageService) { }

  ngOnInit() {
    this.displayState.gridDiv = true;
    this.loadAuditList();
  }

  loadAuditList() {
    this.displayState.workingDiv = true;
    this.systemService.getAuditTrail().subscribe (data => {
      this.allAuditList = [];
      this.auditList = data;
      this.displayState.workingDiv = false;
    });
  }

  // run when table is filtered; capture # of displayed rows
  onFilter(event, dt) {
    // this.utilService.doAudit(event, 'onFilter event');
    this.filteredValuesCount = event.filteredValue.length; // count of displayed rows
  }
  clearTable(table: any) {
    table.clear();
  }

  showToast(msg: Message) {
    this.messageService.add(msg);
  }

  clear() {
    this.messageService.clear();
  }

}
